var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.737 3.477h4.139c1.725 0 3.124 1.343 3.124 3V18.5c0 1.657-1.399 3-3.124 3h-2.38m0 0H6.124C4.4 21.5 3 20.157 3 18.5v-.194l.045-11.548V5.5c0-1.657 1.398-3 3.124-3h6.595m2.732 19c1.726 0 3.124-1.343 3.124-3V8.385M6.645 13.5h8.602m3.373-5.115h-4.502c-.748 0-1.354-.582-1.354-1.3V2.5m5.856 5.885L12.764 2.5M6.644 11V9.5m0 0V6h1.823c1.007 0 1.822.783 1.822 1.75 0 .966-.815 1.75-1.822 1.75H6.645Zm0 7.5h5.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/Policy.010b2f72073e1a83fcdc5cfad3157bf9.svg";
export { ForwardRef as ReactComponent };